module.exports = __webpack_public_path__ + "media/audios/kid/lesson_7/audio34-9f94c532e096050f25426c88799ff6f6.m4a";